"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-program/Event.ts